import PresentationApi from '@/api/presentation'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const getters = {
  canUseCastingSync: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-41804-casting-sync')
  },
  canUseSyncOtherEvents: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-41900-sync-other-events')
  },
}

const actions = {
  getPresentationDetailsByShareCodeAction: async ({ dispatch }, { shareCode, presentationId, payloadDataPresentation }) => {
    const [res] = await Promise.all([
      PresentationApi.getPresentationDetailsByShareCode(shareCode, payloadDataPresentation),
      dispatch('presentationAttributeModule/getPresentationAttributeAction', presentationId, { root: true }),
      dispatch('featureToggles/handlePresentationLoadFlagUnleashByShareCode', shareCode, { root: true }),
    ])
    return res
  },
}

export default {
  namespaced: true,
  getters,
  actions,
}
